import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-page-title',
    templateUrl: './page-title.component.html',
    standalone: false
})
export class PageTitleComponent {

  @Input() heading;
  @Input() subheading;
  @Input() icon;
  @Input() buttonText;

  @Input('buttonCallback') buttonCallback;

}
